import { render, staticRenderFns } from "./pricing-cards.vue?vue&type=template&id=67222d73&scoped=true&"
import script from "./pricing-cards.vue?vue&type=script&lang=js&"
export * from "./pricing-cards.vue?vue&type=script&lang=js&"
import style0 from "./pricing-cards.vue?vue&type=style&index=0&id=67222d73&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67222d73",
  null
  
)

export default component.exports